import { createFileRoute } from "@tanstack/react-router";
import TodoParaTuComercio from "@/pages/TodoParaTuComercio";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/todo-para-tu-comercio")({
  head: () => pageHead("everythingForShop", "es", { links: false }),
  component: TodoParaTuComercio,
});
